




























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import IDoctor from '@/interfaces/doctor';
import { getDoctors } from '@/services/doctors';
import ITeam from '@/interfaces/teams';
import { getTeamsByClient } from '@/services/teams';

@Component({
  components: { UiAutocompleClientsSubsidiaries },
})
export default class UiReferencesTypesHierarchyTeam extends BaseComponent {
  @Prop()
  public item: any;
  @Prop({
    default: {
      team: [],
      clientUnit: [],
    },
  })
  public rules?: any;
  @Prop({
    default: false,
  })
  public disabled: boolean;

  public teams: ITeam[] = [];
  public teamsLoading: boolean = false;

  get team(): string {
    return this.item.referenciaHierarquia;
  }

  set team(val) {
    this.onChangeTeam(val);
  }

  get clientUnit(): any {
    return this.item.unidade;
  }

  set clientUnit(val) {
    this.onChangeClientUnit(val);
  }

  @Watch('item.unidade')
  public onUnitChange(val: any): void {
    if (!val) {
      return;
    }
    this.clientUnit = val;
    this.getTeams(val.id);
  }

  public beforeMount(): void {
    this.onUnitChange(this.item.unidade);
  }

  public onChangeTeam(val: string): void {
    if (!val) {
      return;
    }
    this.$emit('changeTeam', val);
  }

  public onChangeClientUnit(val: any): void {
    if (!val) {
      return;
    }
    this.$emit('changeClientUnit', val);
    this.getTeams(val.id);
  }

  private getTeams(clientId: string): void {
    this.teams = [];
    const currentTeam = this.team;
    this.team = null;

    if (!clientId) {
      return;
    }

    this.teamsLoading = true;

    getTeamsByClient(clientId, { ativo: true }).subscribe((data) => {
      this.teams = data;

      const resultHasItem = () => data.some((item) => item.id === currentTeam);
      if (resultHasItem()) {
        this.team = currentTeam;
      }

      this.teamsLoading = false;
    });
  }
}
